import { Mail, FileText, Shield } from "lucide-react";
import { Link } from "react-router-dom";
import { TermsModal, TermsVariables } from "./TermsModal";
import { FreePlanFooterCta } from "./FreePlanFooterCta";

interface ContestFooterProps {
  termsVariables?: TermsVariables;
  referralBonusEntries?: number;
  endsAt?: string | null;
  startsAt?: string | null;
  planKey?: string;
  hidePoweredByBranding?: boolean;
  useCustomTerms?: boolean;
  customTermsText?: string | null;
  showHelpEmail?: boolean;
  helpEmail?: string | null;
}

export function ContestFooter({
  termsVariables,
  referralBonusEntries = 1,
  endsAt,
  startsAt,
  planKey = "starter", // Default to starter to hide marketing by default
  hidePoweredByBranding = false,
  useCustomTerms,
  customTermsText,
  showHelpEmail,
  helpEmail,
}: ContestFooterProps) {
  return (
    <div className="fade-in space-y-6 mt-8">
      {/* Legal links and help */}
      <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
        {termsVariables && (
          <TermsModal
            termsVariables={termsVariables}
            referralBonusEntries={referralBonusEntries}
            endsAt={endsAt}
            startsAt={startsAt}
            useCustomTerms={useCustomTerms}
            customTermsText={customTermsText}
          >
            <button className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors">
              <FileText className="w-4 h-4" />
              Terms & Conditions
            </button>
          </TermsModal>
        )}

        <Link
          to="/privacy"
          className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
        >
          <Shield className="w-4 h-4" />
          Privacy Policy
        </Link>

        {showHelpEmail && helpEmail && (
          <a
            href={`mailto:${helpEmail}`}
            className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
          >
            <Mail className="w-4 h-4" />
            Help
          </a>
        )}
      </div>

      {/* Powered by / Marketing - Only show if not hidden by Growth plan setting */}
      {!hidePoweredByBranding && (
        <>
          {planKey?.toLowerCase() === "free" ? (
            <FreePlanFooterCta />
          ) : (
            <div className="text-center">
              <Link to="/" className="text-xs text-muted-foreground hover:text-foreground transition-colors inline-block">
                Powered by RaffleKit
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
}